export default [
  {
    path: '/activityEarnings', name: 'activityEarnings', redirect: { name: 'setting' }, meta: { title: '我的' },
  },
  {
    path: '/withdrawInfo', name: 'withdrawInfo', redirect: { name: 'setting' }, meta: { title: '我的' },
  },
  {
    path: '/withdrawSigning', name: 'withdrawSigning', redirect: { name: 'setting' }, meta: { title: '我的' },
  },
  {
    path: '/activityEarningsRecord', name: 'activityEarningsRecord', redirect: { name: 'setting' }, meta: { title: '我的' },
  },
  {
    path: '/withdrawalRecord', name: 'withdrawalRecord', redirect: { name: 'setting' }, meta: { title: '我的' },
  },
  {
    path: '/withdrawalRecordDetail', name: 'withdrawalRecordDetail', redirect: { name: 'setting' }, meta: { title: '我的' },
  },
  {
    path: '/notificationSettings', name: 'notificationSettings', component: () => import('@/pages/account/notificationSettings'), meta: { title: '通知管理' },
  },
  {
    path: '/customerServiceInfo', name: 'customerServiceInfo', component: () => import('@/pages/account/customerServiceInfo'), meta: { title: '客服信息' },
  },
  {
    path: '/bindingWxAccount', name: 'bindingWxAccount', component: () => import('@/pages/user/bindingWxAccount'),
  },
  {
    path: '/wxAuthorizationMessage', name: 'wxAuthorizationMessage', component: () => import('@/pages/user/wxAuthorizationMessage'), meta: { title: '提示', noNavBar: true },
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/user.js